import { render, staticRenderFns } from "./MessageLog.vue?vue&type=template&id=37c38ad8&"
import script from "./MessageLog.vue?vue&type=script&lang=js&"
export * from "./MessageLog.vue?vue&type=script&lang=js&"
import style0 from "./MessageLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MessageLog.vue"
export default component.exports